const ANALYTICS_ID = process.env.REACT_APP_ANALYTICS_ID
const OPTIMIZE_ID = process.env.REACT_APP_OPTIMIZE_ID
const ANALYTICS_DOMAIN = process.env.REACT_APP_ANALYTICS_DOMAIN

function initialize() {
  window.gtag('config', ANALYTICS_ID, {
    optimize_id: OPTIMIZE_ID,
    cookie_domain: ANALYTICS_DOMAIN,
  })
}

export const Tracker = {
  initialize,
}
